import { render, staticRenderFns } from "./directorIndex.vue?vue&type=template&id=b601ae6e&"
import script from "./directorIndex.vue?vue&type=script&lang=js&"
export * from "./directorIndex.vue?vue&type=script&lang=js&"
import style0 from "./directorIndex.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports